import { Collection } from "./Collection";

export class CriticalAreaCampaign extends Collection {

    constructor(collectionInfoModel: any, date: Date) {
        super(date);
        this.CollectionInfoModel = collectionInfoModel;
        this.Type = 'CriticalAreaCampaign';
        this.Guid = collectionInfoModel.CollectionId;

        this.CollectionInfoModel.InspectionTypeId = this.CollectionInfoModel.InspectionTypeId ?? this.CollectionInfoModel.CurrentInspectionTypeId;
    }
}
